import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
ProjectsViewTopBar.displayName = "ProjectsViewTopBar"
